








import Vue from 'vue';
import Component from 'vue-class-component';
import Loader from '@/components/shared/loader/Loader.vue';

@Component({
  components: {
    appLoader: Loader
  }
})
export default class App extends Vue {
  showSnackbar: boolean = false;

  get isLoading(): boolean {
    return this.$store.getters.isLoading;
  }
}
